import { useContext, useEffect, useState } from "react"
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import moment from "moment";
import axios from "axios";
import {isMobile, isTablet } from 'react-device-detect';
import { GetRandomThreeResult } from "../toolUsage/global/Format";

const tool_id =  process.env.REACT_APP_TID_BIZ;
// const global_id = process.env.REACT_APP_GLOBAL_ID;

export const RenderAPI = () => {
    // const session_db = useCombinedData()
    const { tool_state } = useContext(ToolContext)
    const { __SESSION, globalLoader, toolOwned, validateAccount, toolShuffle } = tool_state
    // const { myToolPzl } = navigation_state

    const __runactiveuser = async() => {
        const res = await axios.get("https://ipapi.co/json/");
        const location = JSON.stringify(res.data)
        const ipaddress = res.data.ip

		let data = {
			action: "signin",
			aid: __SESSION.data.ainfo.aid,
			date: moment(new Date()).format('YYYY-MM-DD'),
			tool_id: JSON.parse(tool_id),
            location:location,
            ip_address:ipaddress,
            device_type: isMobile? 2 : isTablet ? 3 : 1
		}
        await rqx.post(`<<global>>/${env()==='local'?'dev':env()}/trail/create`, data)
	}

    const __init = async() => {
        await globalLoader.set(true)
        await __runactiveuser()

        //GET TOOL OWNED
        let prms = __SESSION.data.uaccess[0].role_id === 0 ? {aid:__SESSION.data.ainfo.aid, platform:'business' } : {aid:__SESSION.data.ainfo.aid, platform:'business', ref:0, owner_id:__SESSION.data.uaccess[0].owner_id }
        let resTool = await rqx.get(`<<global>>/${env()}/tools/owned`, prms)
        toolOwned.set(resTool)
        if (resTool.length > 3) {
            const result = GetRandomThreeResult(resTool);
            toolShuffle.set(result)
        }

        let comp_id = __SESSION.data.uaccess[0].company_id
        if (comp_id === null) {
        let bdy = { company_email: "", company_name: "", user_id: atob(__SESSION.data.ainfo.aid).split('_', 2)[1] }
            let res_biz = await rqx.post(`<<biz>>/${env()}/general-maintenance/company/company-setup/createCI`, bdy)
            comp_id = res_biz.id
            __SESSION.set((prev) => ({...prev, uaccess:[{...__SESSION.data.uaccess[0], company_id:comp_id}]}))
        }


        // // PERSONALIZATION FOR BUSINESS
        // const tool_id = env()==='prod'?'103':'13'
        // const user_id = atob(__SESSION.data.ainfo.aid).split('_', 2)[1];
		// const prsnl = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/personalization/read`, {user_id:user_id, tool_id:tool_id, ref:'dashboard'})
        // if (prsnl && prsnl.length === 0) {
        //     myToolPzl.set(true)
        // }

        await globalLoader.set(false)
    }

    const [subscribe, setSubscribe] = useState(true)

    useEffect(() => {
        if (subscribe) {
            if (globalLoader.data) {
                __init()
            }
        }
        return () => setSubscribe(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateAccount.data])
    
    return (
        <></>
    )
}